enum SupportedLanguages {
    FR = 'fr',
    EN = 'en',
    ES = 'es',
    PT = 'pt',
    DEFAULT = 'fr'
  }

export default SupportedLanguages;
